import ModalLayout from "@/ui/modals/ModalLayout.tsx";
import st from "@/styles/Ui.module.scss";
import {useAtom} from "jotai/index";
import {set_pwd_modal_atom, set_pwd_modal_warning} from "@/atoms/modals.ts";
import WritePinFields from "@/ui/WritePinFields.tsx";
import Button from "@/ui/Button.tsx";
import React, {useCallback, useEffect, useState} from "react";
import CommonClass from "@/utils/common.ts";
import {useTranslation} from "react-i18next";
import {profile} from "@/atoms/profile.ts";
import useAuth from "@/hooks/auth.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import LoginLoader from "@/ui/LoginLoader.tsx";
// import ResendCounter from "@/ui/ResendCounter.tsx";
import useIntervals from "@/hooks/intervals.ts";
import {pin_value, pwd_value, resend_interval} from "@/atoms/common.ts";
import EmailIcon from "@/svg/EmailIcon.tsx";
import PhoneIcon from "@/svg/PhoneIcon.tsx";
import ChevroneIcon from "@/svg/ChevronIocn.tsx";
import clsx from "clsx";
import {codeType} from "@/types_and_interfaces/types.ts";
import ResendCounter from "@/ui/ResendCounter.tsx";
import Countdown, {CountdownRenderProps} from "react-countdown";
import WritePwdFields from "@/ui/WritePwdFields.tsx";

const SetPwdModal = () => {

    const [open, setOpen] = useAtom(set_pwd_modal_atom)
    const [changePwdModalWarning, setChangePwdModalWarning] = useAtom(set_pwd_modal_warning)
    const [receive_type, set_receive_type] = useState<codeType>("")
    const [step, set_step] = useState<number>(1)
    const {t} = useTranslation()
    const [user] = useAtom(profile)
    const [otp_error, set_otp_error] = useState<boolean>(false)
    // const [pwd_error, set_pwd_error] = useState<boolean>(false)
    const [pwd_fields] = useAtom(pwd_value);
    const [otp_fields] = useAtom(pin_value);
    
    const [loading, set_loading] = useState<boolean>(false)
    const auth = useAuth()
    const intervals_hook = useIntervals(resend_interval)
    const [interval, set_interval] = useAtom(resend_interval)
    const is_interval = Boolean(interval !==  null && interval.length)
    
    const set_loading_handler = useCallback((x: boolean) => {
        set_loading(x);
    }, [set_loading]);

    const set_otp_err_handler = useCallback((x: boolean) => {
        set_otp_error(x);
    }, [set_otp_error]);

    // const set_pwd_err_handler = useCallback((x: boolean) => {
    //     set_pwd_error(x);
    // }, [set_pwd_error]);

    const onClose = () => {
        setOpen(false)
        eventEmitter.emit(CommonClass.CustomEvents.reset_otp_value)
        eventEmitter.emit(CommonClass.CustomEvents.reset_pwd_value)
        setChangePwdModalWarning("")
    }
    

    const resetHandlerStepTwo = async (e: React.FormEvent<HTMLFormElement>) => {

        e.preventDefault()
        
        let otp = otp_fields.join("")
        // let device_uid = localStorage.getItem(CommonClass.local_storage_fields.device_uid)
        let value = receive_type === "email" ? user?.email : user?.phone
        let pwd = pwd_fields.join("")


        let enable = await auth.resetPwdSt2(
            value,
            otp,
            pwd,
            receive_type
        )
        
        if(enable){
            onClose()
        }
    }

    const resetHandlerStepOne = async (type?: codeType) => {

        if(!user) return
        
        set_receive_type(type || "")
        
        let reset = await auth.resetPwdSt1(type?.length ? type : receive_type)

        if(reset) {
            set_step(2)
            eventEmitter.emit(CommonClass.CustomEvents.set_resend_interval, false)
            intervals_hook.setIntervalHandler()
        }
    }
    
    const buttons = [
        {
            label: "phone",
            icon: <PhoneIcon />,
            value: t("phone1"),
            onClick:() => resetHandlerStepOne("phone"),
            visible: Boolean(user?.phone.length)
        },
        
        {
            label: "email",
            icon: <EmailIcon />,
            value: t("email_address"),
            onClick:() => resetHandlerStepOne("email"),
            visible: Boolean(user?.email.length)
        }
    ]



    useEffect(() => {

        eventEmitter.on(CommonClass.CustomEvents.set_req_load, set_loading_handler)
        eventEmitter.on(CommonClass.CustomEvents.set_err_otp, set_otp_err_handler)
        // eventEmitter.on(CommonClass.CustomEvents.set_err_pwd, set_pwd_err_handler)

        return () => {
            eventEmitter.off(CommonClass.CustomEvents.set_req_load, set_loading_handler)
            eventEmitter.off(CommonClass.CustomEvents.set_err_otp, set_otp_err_handler)
            // eventEmitter.off(CommonClass.CustomEvents.set_err_pwd, set_pwd_err_handler)
        }

    }, [set_loading_handler, set_otp_err_handler /*, set_pwd_err_handler*/]);


    return (
        <ModalLayout
            className={st.edit_profile_modal}
            open={open}
            innerClassName={clsx(st.edit_profile_modal_inner, st.set_pwd)}
            on_close_state={onClose}
        >
            <>
                <div className={st.heading}>

                    {(step === 1 && changePwdModalWarning.length > 0) && (
                        <div className={st.warn}>
                            {changePwdModalWarning}
                        </div>
                    )}

                    <h4>{t("reset_pwd")}</h4>
                    
                    {step === 1 && (
                        <p>
                            {t("select_otp_type")}
                        </p>
                    )}
                    
                </div>
                
                {step === 1 && (
                    <div className={clsx(st.content, st.min_gap)}>
                        {buttons.map((x, i) => {
                            
                            return x.visible && (
                                <button
                                    disabled={is_interval}
                                    type={"button"}
                                    className={st.otp_type_btn}
                                    key={`select_set_pwd_otp_${x.label + i}`}
                                    onClick={x.onClick}
                                >
                                    <div className={st.left}>
                                        {x.icon}
                                        {x.value}
                                    </div>
                                    
                                    <ChevroneIcon  className={st.chevrone}/>
                                </button>
                            )
                        })}
                        
                        {interval !==  null && interval.length ? (
                            <div className={st.countdown}>
                                {t("resend_in")}
                                
                                <Countdown
                                    date={JSON.parse(interval).interval}
                                    renderer={(args) => renderer({...args})}
                                    intervalDelay={1000}
                                    zeroPadTime={2}
                                    onComplete={() => {
                                        set_interval("")
                                    }}
                                />
                            </div>
                        ) : null}
                    </div>
                )}
                
                {step === 2 && (
                    <div className={st.content}>
                        <p className={st.info}>
                            {receive_type == "email" ? t("email_code_info_text3") : t("number_code_info_text1")}
                        </p>
                        
                        <form onSubmit={resetHandlerStepTwo} autoComplete={'off'}>
                            
                            <div className={st.labels}>
                                <span>
                                    {t("write_otp")}
                                </span>
                                
                                <WritePinFields
                                    error={otp_error}
                                    className={st.pin}
                                />
                                
                            </div>
                            
                            <div className={st.labels}>
                                <span>
                                    {t("write_new_pwd")}
                                </span>
                                
                                <WritePwdFields
                                    // error={pwd_error}
                                    className={st.pwd}
                                />
                            </div>
                            
                            {/*<PasswordInput error={pwd_error}/>*/}
                            
                            <div className={st.controller_row}>
                                
                                <Button
                                    outlined
                                    type={"button"}
                                    className={st.back}
                                    onClick={() => {
                                        set_step(1)
                                    }}
                                    disabled={is_interval}
                                >
                                    <ChevroneIcon />
                                    {t("back")}
                                </Button>
                                
                                <Button
                                    className={st.submit}
                                    type={"submit"}
                                >
                                    {t("set_pin")}
                                </Button>
                            </div>
                            
                        
                        </form>
                        
                        <ResendCounter
                            onClick={resetHandlerStepOne}
                            interval_atom={resend_interval}
                        />
                        
                    </div>
                )}
                
                {loading && <LoginLoader/>}
            
            </>
        
        </ModalLayout>
    )
}

const renderer = (args: CountdownRenderProps) => {
    const {minutes, seconds} = args;
    const padValue = (value: number) => (value < 10 ? `0${value}` : `${value}`);
    
    return (
        <div>
            {padValue(minutes) || "00"} :
            {" " + padValue(seconds) || " 00"}
        </div>
    );
    
};

export default SetPwdModal